module.exports = __webpack_public_path__ + "static/media/document.14cc7926.png";